import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavigationBarComponent, NavigationMenuItem } from './layout/navigation-bar/navigation-bar.component';
import { UserService } from '../core/services/user.service';
import { PlantationSelectPanelComponent } from './services/plantation-select-panel/plantation-select-panel.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { NotificationService } from '../core/services/notification.service';
import { NotificationSignalrService } from '../core/services/notification-signalr.service';
import { PlantationService } from '../core/services/plantation.service';
import { MixpanelTrackerService } from '../core/analytics/mixpanel-tracker.service';
import { AppConfigService } from '../core/services/app-config.service';

@Component({
  selector: 'app-features',
  imports: [SharedModule, RouterModule, NavigationBarComponent, PlantationSelectPanelComponent, NotificationsComponent],
  templateUrl: './features.component.html',
  styleUrl: './features.component.less',
  providers: [ConfirmationService],
})
export class FeaturesComponent implements OnInit {
  activeMenu: NavigationMenuItem;
  visibleSelectPlantationPanel = false;

  notificationsDrawerVisible = false;
  notificationPopoverOpen = false;
  isCSIDomain = window.location.hostname.includes('sustainability.doktar');
  
  constructor(
    private _userService: UserService,
    private notificationService: NotificationService,
    private notificationSignalrService: NotificationSignalrService,
    private plantationService: PlantationService,
    private mixpanelTracker: MixpanelTrackerService,
    private appConfigService: AppConfigService
  ) {
    window.addEventListener('click', (e: MouseEvent) => {
      const htmlElement = e.target as HTMLElement;

      const isElementInFilter =
        document.getElementById('navigation_wrapper')?.contains(htmlElement) ||
        document.getElementById('land-plantation-popover')?.contains(htmlElement) ||
        document.querySelector('.PlantationSelectPanelFilterModalComponent')?.contains(htmlElement);

      if (!isElementInFilter) {
        this.visibleSelectPlantationPanel = false;
      }
    });

    // Listen for custom event to open notifications panel from toast
    window.addEventListener('open-notifications-panel', () => {
      this.onToggleNotifications(true);
    });
  }

  async ngOnInit(): Promise<void> {
    // Initialize user if undefined
    this._userService.initializeUserService().then(() => {
      this._userService.loadUserProfile().subscribe();
    });

    this.plantationService?.visibleSelectPlantationPanel$?.subscribe((show) => {
      setTimeout(() => {
          this.visibleSelectPlantationPanel = show;
        }, 100);
    });

    // Wait until app and auth configuration are loaded, then bootstrap SignalR
    await this.appConfigService.initializeApp();
    await this.appConfigService.initializeAuthenticatedConfigurations();
    await this.notificationSignalrService.bootstrap();
  }

  /**
   * Handle notification panel toggle
   * Triggers notification fetch when panel is opened
   */
  onToggleNotifications(visible: boolean): void {
    this.notificationsDrawerVisible = visible;

    // If panel is being opened, trigger a fresh notification fetch and track Notifications Viewed
    if (visible) {
      this.notificationService.fetchOnPanelOpen().subscribe({
        next: () => {
          const count = this.notificationService.getUnreadCount();
          this.mixpanelTracker.trackNotificationsViewed({
            'Number of new notifications': count,
          });
        },
      });
    }
  }

  /**
   * Handle notification popover state change
   */
  onNotificationPopoverStateChange(isOpen: boolean): void {
    this.notificationPopoverOpen = isOpen;
  }

  /**
   * Handle notifications drawer mouse leave - only close if popover is not open
   */
  onNotificationsMouseLeave(): void {
    if (!this.notificationPopoverOpen) {
      this.notificationsDrawerVisible = false;
    }
  }
}
